import { useState } from "react";
import styled from "styled-components";

interface ImagePreviewProps {
  deleteHandler: () => void;
}

export const DeletePreview = (props: ImagePreviewProps) => {
  const { deleteHandler } = props;
  const [showButtons, setShowButtons] = useState(false);

  return (
    <BorderedContainer
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={() => {
        setShowButtons(true);
      }}
      onMouseLeave={() => {
        setShowButtons(false);
      }}
    >
      {showButtons && (
        <Mask>
          <DeleteButton
            title="Удалить файл"
            type="button"
            onClick={() => {
              deleteHandler();
              setShowButtons(false);
            }}
          >
            <span role="img" aria-label="delete">
              <svg
                viewBox="64 64 896 896"
                focusable="false"
                data-icon="delete"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  // eslint-disable-next-line max-len
                  d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                ></path>
              </svg>
            </span>
          </DeleteButton>
        </Mask>
      )}
    </BorderedContainer>
  );
};

const BorderedContainer = styled.div`
  pointer-events: all;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 104px;
  height: 104px;
  margin: 0;
  vertical-align: top;

  margin: 0;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  border-radius: 2px;
  display: flex;
  align-items: center;
`;

const Mask = styled.div`
  position: absolute;
  z-index: 100;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    fill: white;
  }
`;
const DeleteButton = styled.button`
  border: none;
  background: transparent;
  height: 20px;
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
`;

const Image = styled.img`
  width: 86px;
  height: 86px;
  object-fit: contain;
`;
